import { EgretLoadable } from "egret";
import { authRoles } from "~/app/auth/authRoles";

const Logs = EgretLoadable({
  loader: () => import("./index"),
});

const LogsRoute = [
  {
    path: "/logs",
    exact: true,
    component: Logs,
    auth: authRoles.all,
  },
];

export default LogsRoute;
